import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/* 좌(식별) ↔ 우(재시도 콜아웃) 배치. 우측을 세로 중앙 정렬해 카드 높이를 늘리지 않음. */
export const rowStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.space.md}px;
`;

export const titleStyle = css`
  margin: 0;
  font-size: ${theme.fontSize.xl}px;
  font-weight: 700;
  color: ${theme.color.text};
`;

export const subStyle = css`
  margin: ${theme.space.xs}px 0 0;
  font-size: ${theme.fontSize.md}px;
  color: ${theme.color.textMuted};
`;

/* 재시도 실행 콜아웃 — 좌측 강조선 + 연한 primary 면. 카드 우측 빈 공간에 배치. */
export const retryNoteStyle = css`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  padding: ${theme.space.sm}px ${theme.space.md}px;
  border-radius: ${theme.radius.md}px;
  border-left: 3px solid ${theme.color.secondary};
  background: ${theme.color.secondary}14;
  font-size: ${theme.fontSize.md}px;
`;

/* ↩ 아이콘 — 강조색. */
export const retryIconStyle = css`
  color: ${theme.color.secondary};
  font-weight: 700;
  line-height: 1;
`;

/* 설명 텍스트 — 보조색. */
export const retryTextStyle = css`
  color: ${theme.color.textMuted};
`;

/* 원본 Job 링크 — 버튼 리셋 후 링크처럼. hover 시 밑줄. */
export const retryLinkStyle = css`
  padding: 0;
  border: 0;
  background: none;
  color: ${theme.color.secondary};
  font-size: inherit;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  cursor: pointer;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    color: ${theme.color.text};
    cursor: default;
  }
`;
